import { AddOn } from './add-on';
import type { AddOnsResponse } from '../../repositories';

export class AddOnsVO {
  private readonly addOns: AddOn[];

  constructor(response: AddOnsResponse) {
    this.addOns = response.map((addOn) => new AddOn(addOn));
  }

  public getAddOns() {
    return this.addOns;
  }

  public getExistingAddOnsIds() {
    return this.addOns.filter((addon) => addon.getPurchased()).map((addon) => addon.getId());
  }
}
